export default __webpack_public_path__ + "static/media/e-filing-logotype-d.781624a4.svg";